import { getGlobalItem } from '@office-start/web-storage-utility';
import { searchCenterUrlKey } from './constants';
export function getSearchCenterUrlFromCache() {
    var searchCenterUrlFromLocalStorage = getGlobalItem(searchCenterUrlKey);
    return searchCenterUrlFromLocalStorage !== null && searchCenterUrlFromLocalStorage !== void 0 ? searchCenterUrlFromLocalStorage : undefined;
}
//# sourceMappingURL=getSearchCenterUrlFromCache.js.map